/**
 * 页面控制
 */
import BodyClass from './body-class' // 页面顶层样式
import BodyTitle from './body-title' // 页面标题
import BodyUser from './body-user' // 页面用户
export default {
  mixins: [
    BodyClass, // 绑定Body样式
    BodyTitle, // 绑定Body样式
    BodyUser
  ]
}
